// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__1EzkA","content":"RecentSearches_content__OFv8B"};